import {
  MarketingOptInSetting,
  MerchantMarketingPreference as RpcMerchantMarketingPreference,
} from 'rpc/model/squareup/buyerportal/preference/marketing';

// eslint-disable-next-line unicorn/prefer-export-from
export { MarketingOptInSetting };

export interface DomainMerchantMarketingPreference {
  merchantId: string;
  merchantDisplayName: string;
  merchantImageUrl: string;
  setting: MarketingOptInSetting;
}

export interface MarketingPreferencesData {
  globalSetting: MarketingOptInSetting;
  merchantPreferences: DomainMerchantMarketingPreference[];
  totalMerchants: number;
}

export const MarketingPreferencesConverter = {
  fromMerchantPreference(
    rpc: RpcMerchantMarketingPreference
  ): DomainMerchantMarketingPreference {
    return {
      merchantDisplayName: rpc.merchant?.displayName ?? '',
      merchantId: rpc.merchant?.id ?? '',
      merchantImageUrl: rpc.merchant?.imageUrl ?? '',
      setting: rpc.setting ?? MarketingOptInSetting.MARKETING_OPT_IN_UNKNOWN,
    };
  },
};

export function isMarketingOptedIn(setting: MarketingOptInSetting): boolean {
  return setting === MarketingOptInSetting.MARKETING_OPT_IN;
}
